export default `
#patch2-table-parent .rt-resizable-header{
font-size: small !important;
}

#patch2-table-parent .rt-td{
  align-items: center !important;
}

#patch2-table-parent .rt-tr{
  height: 35px; !important;
}

#patch2-modal-parent .modal-content {
  width: 93%;
}

#patch2-article-dropdown-parent .ncss-row {
  margin-left: 204px;
}

.patch2-toggle {
    padding: 12px;
    padding-right: 25px;
    width: 50%;
    flex-direction: row-reverse;
    display: flex;
    align-items: flex-end;
}
.patch2-toggleLabelActive {
    font-weight: bold;
}

  /* Toggle Switch Styles */
.patch2-switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
    margin: 0 10px;
}
.table-toggle-switch {
  height: 25px;
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  margin: 0 10px;
}
  
.patch2-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.patch2-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #faf6f6;
    transition: 0.4s;
    border-radius: 34px;
    border: 2px solid #030c13;
  }
  
  .patch2-slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    top: 2px;
    background-color: rgb(2, 0, 0);
    transition: 0.4s;
    border-radius: 50%;
  }

.table-toggle-slider {
    height: 22px;
    width: 50px;
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #faf6f6;
    transition: 0.4s;
    border-radius: 34px;
    border: 2px solid #030c13;
}

.table-toggle-slider:before {
  height: 14px;
  width: 14px;
  position: absolute;
  content: "";
  left: 4px;
  bottom: 4px;
  top: 2px;
  background-color: rgb(2, 0, 0);
  transition: 0.4s;
  border-radius: 50%;
}

  
  input:checked + .patch2-slider {
    background-color: #030c13;
  }
  
  input:checked + .patch2-slider:before {
    transform: translateX(26px);
    background-color: #faf6f6;
  }

  `;
